import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

export const VerifiedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.isVerified$;
};
